import { debug } from "./logger"

export const read = (key) => {
  debug(`[utilities][storage.read] ${key}`)
  const raw = window.localStorage.getItem(key)
  try {
    return (raw && JSON.parse(raw)) || {}
  } catch (e) { return {} }
}

export const write = (key, object) => {
  debug(`[utilities][storage.write] ${key}`)
  window.localStorage.setItem(key, JSON.stringify(object))
}



// WEBPACK FOOTER //
// ./src/utilities/local-storage.js